import { countryCodes } from "./country_codes.js";
import { showToast, showGlobalPreloader, hideGlobalPreloader } from "./utils.js";

document.addEventListener("DOMContentLoaded", () => {
  let loginDataGlobal; // Declare the variable here

  const identifierTypeDropdown = document.getElementById(
    "identifier-type-dropdown",
  );
  const identifierTypeInput = document.getElementById("identifier-type");
  const identifierInput = document.getElementById("identifier");
  const phoneInputContainer = document.getElementById("phone-input-container");
  const phoneInput = document.getElementById("phone");
  const phoneNumberError = document.getElementById("phone-number-error");

  function validatePhoneNumber() {
    const currentPhone = phoneInput.value.trim();
    phoneNumberError.textContent = ""; // Clear previous errors

    const phoneRegex = /^\d*$/; // Only allow digits
    if (!phoneRegex.test(currentPhone)) {
      phoneNumberError.textContent = "Phone number must contain only digits.";
      phoneInput.setCustomValidity("Phone number must contain only digits.");
    } else {
      phoneInput.setCustomValidity("");
    }
  }

  // Add event listeners
  if (phoneInput) {
    phoneInput.addEventListener("input", validatePhoneNumber);
  }

  const countryCodeDropdown = document.getElementById("country-code-dropdown");
  if (countryCodeDropdown) {
    countryCodeDropdown.addEventListener("click", (event) => {
      if (event.target.tagName === "A") {
        // A country code was selected, re-validate phone number
        validatePhoneNumber();
      }
    });
  }

  if (identifierTypeDropdown) {
    identifierTypeDropdown.addEventListener("dropdown-change", (e) => {
      const selectedType = e.detail.value;
      if (identifierTypeInput) {
        identifierTypeInput.value = selectedType;
      }
      if (selectedType === "phone") {
        phoneInputContainer.style.display = "flex";
        identifierInput.style.display = "none";
        identifierInput.required = false;
        phoneInput.required = true;
      } else {
        phoneInputContainer.style.display = "none";
        identifierInput.style.display = "block";
        identifierInput.required = true;
        phoneInput.required = false;
        identifierInput.placeholder = `Enter your ${selectedType}`;
      }
    });
  }

  const loginForm = document.getElementById("login-form");
  const otpForm = document.getElementById("otp-form");
  const otpInput = document.getElementById("otp-input");
  const countryCodeDropdownOptions = document.querySelector(
    "#phone-input-container #country-code-dropdown .dropdown-options",
  );
  const selectedCountryCodeSpan = document.querySelector(
    "#phone-input-container #selected-country-code",
  );
  const hiddenCountryCodeInput = document.querySelector(
    "#phone-input-container #country-code",
  );

  // Populate country codes dropdown
  if (countryCodeDropdownOptions && typeof countryCodes !== "undefined") {
    countryCodes.forEach((country) => {
      const a = document.createElement("a");
      a.href = "#";
      a.setAttribute("data-value", country.code);
      a.textContent = `${country.code} (${country.name})`;
      countryCodeDropdownOptions.appendChild(a);
    });

    // Set initial selected value (e.g., India +91)
    const defaultCountry = countryCodes.find(
      (country) => country.code === "+91",
    );
    if (defaultCountry) {
      selectedCountryCodeSpan.textContent = `${defaultCountry.code} (${defaultCountry.name})`;
      hiddenCountryCodeInput.value = defaultCountry.code;
    }
  }

  if (loginForm) {
    loginForm.addEventListener("submit", async function (event) {
      event.preventDefault();

      const identifierType = document.getElementById("identifier-type").value;
      let identifier;

      if (identifierType === "phone") {
        validatePhoneNumber();
        if (phoneInput.checkValidity() === false) {
          showToast(phoneNumberError.textContent || "Invalid phone number", "error");
          return;
        }
        const countryCode = document.getElementById("country-code").value;
        const phone = document.getElementById("phone").value;
        identifier = countryCode + phone;
      } else {
        identifier = document.getElementById("identifier").value.trim();
      }

      const password = document.getElementById("password").value;

      // --- Input Validation ---
      let isValid = true;
      let errorMessage = "";

      if (identifierType === "email") {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(identifier)) {
          isValid = false;
          errorMessage = "Please enter a valid email address.";
        }
      } else if (identifierType === "phone") {
        const phoneRegex = /^\+?[1-9]\d{1,14}$/; // E.164 format-like
        if (!phoneRegex.test(identifier)) {
          isValid = false;
          errorMessage = "Please enter a valid phone number with country code.";
        }
      } else {
        // 'username'
        // Basic username validation (e.g., alphanumeric, 3-20 chars)
        const usernameRegex = /^[a-zA-Z0-9_.]{3,20}$/;
        if (!usernameRegex.test(identifier)) {
          isValid = false;
          errorMessage = "Username must be 3-20 alphanumeric characters (dots and underscores allowed).";
        }
      }

      if (!isValid) {
        showToast(errorMessage, "error", loginForm.parentNode);
        return; // Stop the submission
      }
      // --- End of Input Validation ---

      showGlobalPreloader("Sending OTP...");

      loginDataGlobal = { identifier, password, identifierType }; // Pass identifierType to backend

      try {
        const response = await fetch("/api/auth/login", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(loginDataGlobal),
        });
        const data = await response.json(); // Parse JSON regardless of status for error messages

        if (
          response.ok &&
          (data.otp_required || data.message === "OTP sent for verification.")
        ) {
          document.getElementById("global-preloader-message").textContent =
            "OTP Sent Successfully!";
          setTimeout(() => {
            showToast(
              "OTP sent to your email. Please verify.",
              "info",
              loginForm.parentNode,
            );
            loginForm.style.display = "none"; // Hide login form
            otpForm.style.display = "block"; // Show OTP form
          }, 1000); // Show success message for 1 second before proceeding
        } else if (response.ok && data.access_token) {
          localStorage.setItem("access_token", data.access_token);
          if (data.refresh_token) {
            localStorage.setItem("refresh_token", data.refresh_token);
          }
          localStorage.setItem("user_role", data.user_role);
          localStorage.setItem("user_id", data.user_id);
          localStorage.setItem("username", data.username);
          localStorage.setItem("institution_id", data.institution_id); // Store institution_id
          if (data.subscription_tier) {
            localStorage.setItem(
              "user_subscription_tier",
              data.subscription_tier,
            );
          }
          showToast("Login successful!", "success", loginForm.parentNode);
          window.location.href = data.redirect_url; // Redirect to dashboard
        } else {
          const errorMessage = data.error || "Login failed.";
          showToast(errorMessage, "error", loginForm.parentNode);
        }
      } catch (error) {
        showToast(
          "Network error: " + error.message,
          "error",
          loginForm.parentNode,
        );
      } finally {
        hideGlobalPreloader();
      }
    });
  }

  if (otpForm) {
    otpForm.addEventListener("submit", async function (event) {
      event.preventDefault();
      const otpCode = otpInput.value;

      showGlobalPreloader("Verifying OTP...");

      try {
        const response = await fetch("/api/auth/login/verify_otp", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            identifier: loginDataGlobal.identifier,
            otp: otpCode,
            identifierType: loginDataGlobal.identifierType, // Pass the type here
          }),
        });

        const data = await response.json();

        if (response.ok && data.access_token) {
          localStorage.setItem("access_token", data.access_token);
          if (data.refresh_token) {
            localStorage.setItem("refresh_token", data.refresh_token);
          }
          localStorage.setItem("user_role", data.user_role);
          localStorage.setItem("user_id", data.user_id);
          localStorage.setItem("username", data.username);
          localStorage.setItem("institution_id", data.institution_id); // Store institution_id
          if (data.subscription_tier) {
            localStorage.setItem(
              "user_subscription_tier",
              data.subscription_tier,
            );
          }
          showToast(
            "OTP verified. Login successful!",
            "success",
            otpForm.parentNode,
          );

          // Redirect to the appropriate page based on role
          if (data.redirect_url) {
            window.location.href = data.redirect_url;
          } else {
            // Fallback: If for some reason redirect_url is not provided,
            // redirect to a default dashboard. This should ideally not be reached.
            window.location.href = "/dashboard";
          }
        } else {
          const errorMessage = data.error || "OTP verification failed.";
          showToast(errorMessage, "error", otpForm.parentNode);
        }
      } catch (error) {
        showToast(
          "Network error: " + error.message,
          "error",
          otpForm.parentNode,
        );
      } finally {
        hideGlobalPreloader();
      }
    });
  }
});
